/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    h3: "h3",
    ul: "ul",
    li: "li",
    a: "a",
    pre: "pre"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Dynamically change data"
    }), "\n", _jsxs(_components.p, {
      children: ["You can manipulate the used data dynamically, either by changing the ", _jsx(_components.code, {
        children: "data"
      }), " property or during user events like ", _jsx(_components.code, {
        children: "on_type"
      }), " or ", _jsx(_components.code, {
        children: "on_focus"
      }), ". The following properties and methods are there to use:"]
    }), "\n", _jsx(_components.h3, {
      children: "Methods"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "updateData"
        }), " replace all data entries."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "emptyData"
        }), " remove all data entries."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "resetSelectedItem"
        }), " will invalidate the selected key."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "revalidateSelectedItem"
        }), " will re-validate the internal selected key on the given ", _jsx(_components.code, {
          children: "value"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "revalidateInputValue"
        }), " will re-validate the current input value and update it – based on the given ", _jsx(_components.code, {
          children: "value"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "setInputValue"
        }), " update the input value."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "clearInputValue"
        }), " will set the current input value to an empty string."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "focusInput"
        }), " will set focus on the input element."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "showIndicator"
        }), " shows a progress indicator instead of the icon (inside the input)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "hideIndicator"
        }), " hides the progress indicator inside the input."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "showIndicatorItem"
        }), " shows an item with a ", _jsx(_components.a, {
          href: "/uilib/components/progress-indicator",
          children: "ProgressIndicator"
        }), " status as an data option item."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "showNoOptionsItem"
        }), " shows the \"no entries found\" status as an data option item."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "setVisible"
        }), " shows the ", _jsx(_components.a, {
          href: "/uilib/components/fragments/drawer-list",
          children: "DrawerList"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "setHidden"
        }), " hides the ", _jsx(_components.a, {
          href: "/uilib/components/fragments/drawer-list",
          children: "DrawerList"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "showAllItems"
        }), " shows all ", _jsx(_components.a, {
          href: "/uilib/components/fragments/drawer-list",
          children: "DrawerList"
        }), " items."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "setMode"
        }), " switch the mode during runtime."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "debounce"
        }), " a debounce method with a cancel invocation method on repeating calls. There is ", _jsx(_components.a, {
          href: "/uilib/helpers/functions/#debounce",
          children: "more documentation"
        }), " about this method."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Properties"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "dataList"
        }), " contains all the data entries."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Example"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "<Autocomplete\n  on_focus={({ updateData, showIndicator }) => {\n    showIndicator()\n    setTimeout(() => {\n      updateData(topMovies)\n    }, 1e3)\n  }}\n  on_type={({ value /* updateData, ... */ }) => {\n    console.log('on_type', value)\n  }}\n/>\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
